import { createIndex } from "@omnia/shared/utils/array";
import { CroppingPermission, CroppingPermissions } from "./types";

export function convertCroppingPermissionsFromApi(permissions: CroppingPermission[]): CroppingPermissions {
    permissions = (permissions ?? []).map(p => ({ ...p, authorized: p.authorized ?? false }))
    return createIndex(permissions, p => p.croppingId)
}